import { RestSlice } from '../../../../../redux/rest.slice';
import { IppDataSourceUnit } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippUnitSlice = new RestSlice<IppDataSourceUnit>(
	localizationService.getLocalizedString('ipp.industryAccount.dataProviders.translations.units.heading'),
	Resource.IppDataSourceUnits
);
export default ippUnitSlice.rests.reducer;
